<div class="main" [ngClass]="{ 'is-portrait': isPortraitDevice }">
    <div class="container" [ngClass]="{ 'is-portrait': isPortraitDevice }">
        <div class="headlines">
            <h1 *ngIf="!isPortraitDevice" class="headline-m">
                {{ additionalDataTitle | translate }}
            </h1>

            <p class="subtitle-m">
                {{ additionalDataSubtitle | translate }}
            </p>
        </div>

        <form class="form" [formGroup]="formGroup">
            <!-- 
            <span class="text-paragraph">
                {{ loanHead | translate }}
            </span>
             -->
            <div class="form-row">
                <span class="text-paragraph">
                    {{ loanHead | translate }}
                </span>
            </div>

            <!-- loanSituationOptions -->
            <div class="form-row">
                <div class="form-field">
                    <p-selectButton
                        id="loanSituation"
                        formControlName="loanSituation"
                        class="p-selectbutton"
                        [options]="loanSituationOptions"
                        optionLabel="label"
                        optionValue="code"
                        (onOptionClick)="onChangeLoan($event)"
                    ></p-selectButton>
                </div>
            </div>

            <!-- Option  YES -->

            <div *ngIf="yesSelected && showForm" class="form-row">
                <span class="text-paragraph">
                    {{ monthlyCostLabel | translate }}
                </span>
            </div>

            <!-- cost -->
            <div *ngIf="yesSelected && showForm" class="form-row">
                <div class="form-input-row">
                    <div class="form-input">
                        <input
                            type="number"
                            class="input"
                            formControlName="cost"
                            id="cost"
                            name="cost"
                            placeholder=""
                            (keyup)="onChangeCost($event)"
                        />

                        <label class="input-label" for="cost">{{ monthlyCostInput | translate }}</label>

                        <div *ngIf="this.formGroup.controls.cost.valid" class="input-icon">
                            <!--//-EJEMPLO-INPUT-->
                            <i class="ri-check-line class-icono"></i>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 
            <div *ngIf="yesSelected && showForm" class="form-row">




                <div class="form-floating form-floating-group flex-grow-1">
                    <input
                        type="number"
                        class="textarea form-control"
                        formControlName="cost"
                        id="cost"
                        name="cost"
                        placeholder=""
                        (keyup)="onChangeCost($event)"
                    />
                    <label for="cost">{{ monthlyCostInput | translate }}</label>
                </div>
            </div>
             -->
        </form>

        <div class="actions">
            <button
                *ngIf="!isPortraitDevice"
                pripple=""
                class="button-secondary button-next"
                type="button"
                [disabled]="backButtonDisabled"
                (click)="onClicButtonBack()"
            >
                <span class="ri-arrow-left-line p-button-icon p-button-icon-left ng-star-inserted"></span>
                <span class="p-button-label-right">{{ backButton | translate }}</span>
            </button>

            <button
                pripple=""
                class="button-primary button-next"
                type="button"
                [disabled]="continueButtonDisabled"
                (click)="onClicButtonContinue()"
                [ngClass]="{ 'is-portrait': isPortraitDevice }"
            >
                <span class="p-button-label-left">{{ continueButton | translate }}</span>
                <span class="ri-arrow-right-line p-button-icon p-button-icon-right ng-star-inserted"></span>
            </button>
        </div>
    </div>

    <div *ngIf="isPortraitDevice">
        <app-footer></app-footer>
    </div>

    <div class="chat-layer">
        <app-chat-layer></app-chat-layer>
    </div>
</div>
